import axios from 'axios';

export default {
    call: axios.create({
        baseURL: process.env.REACT_APP_API_BASEURL
    })
};

// Helper function to handle API errors consistently
// const handleApiError = (error) => {
//     console.error("API Error:", error);
    
//     const errorMessage = error.response?.data 
//         ? JSON.stringify(error.response.data)
//         : "An error occurred while fetching location data";
        
//     alert(errorMessage);
// };